import { useRef } from 'react';
import { useQueryContext } from '@sierralabs/query-ui';
import { useTraceBoard } from '../../common/trace-board/hooks/useTraceBoard';
import { getQueryArrayValue, getQueryValue } from '../component/useQueryDisplayValue';
export function useSiteTraceBoard(component) {
    var _a;
    const itemsDataRef = useRef(new WeakMap());
    const { queries } = useQueryContext();
    const componentColumns = ((_a = component.props) === null || _a === void 0 ? void 0 : _a.columns) || [];
    const columns = componentColumns.map(column => {
        return {
            id: column.id,
            name: column.name || '',
            linkedColumnIds: (column.linkedColumns || []).map(linkedColumn => linkedColumn.id)
        };
    });
    const getColumnQuery = (columnId) => {
        const column = componentColumns.find(column => column.id === columnId);
        const queryId = column === null || column === void 0 ? void 0 : column.queryId;
        return queryId ? queries.find(query => query.id === queryId) : undefined;
    };
    const resolveLinkedFields = (fields, data, linkedColumns, query, type) => {
        // get configured linked columns of column
        for (const linkedColumn of linkedColumns || []) {
            // get linked fields that have configured source and target values
            const linkedFields = (linkedColumn.fields || []).filter((field) => {
                return !!(field.source && field.target);
            });
            for (const linkedField of linkedFields) {
                const queryField = linkedField[type];
                // skip if already exists
                if (typeof fields[queryField] !== 'undefined') {
                    continue;
                }
                const values = getQueryArrayValue(data, query, queryField);
                fields[queryField] = values;
            }
        }
    };
    const createItem = (columnId, data) => {
        // get configuration for column
        const column = componentColumns.find(column => column.id === columnId);
        const fields = (column === null || column === void 0 ? void 0 : column.itemFields) || {};
        const query = getColumnQuery(columnId);
        const getValue = (queryField) => {
            var _a;
            return query && queryField
                ? (_a = getQueryValue(data, query, queryField)) !== null && _a !== void 0 ? _a : ''
                : '';
        };
        const item = {
            data,
            columnId,
            linkedItems: [],
            id: getValue(fields.id),
            title: getValue(fields.title),
            description: getValue(fields.description),
            deleted: !!getValue(fields.deleted)
        };
        // precompute values here instead of inside the
        // isLinked check to minimize repetitive operations
        const linkedFields = {};
        if (query) {
            for (const componentColumn of componentColumns) {
                const isSource = columnId === componentColumn.id;
                const linkedColumns = isSource
                    ? (column === null || column === void 0 ? void 0 : column.linkedColumns) || []
                    : (componentColumn.linkedColumns || []).filter(linkedColumn => linkedColumn.id === columnId);
                const type = isSource ? 'source' : 'target';
                resolveLinkedFields(linkedFields, data, linkedColumns, query, type);
            }
        }
        itemsDataRef.current.set(data, { query, fields: linkedFields });
        return item;
    };
    const isLinked = (source, target) => {
        // get configured linked columns of source column
        const sourceColumn = componentColumns.find(column => column.id === source.columnId);
        const linkedColumns = (sourceColumn === null || sourceColumn === void 0 ? void 0 : sourceColumn.linkedColumns) || [];
        const sourceItemData = itemsDataRef.current.get(source.data);
        const targetItemData = itemsDataRef.current.get(target.data);
        return !!(source.data &&
            target.data &&
            sourceItemData &&
            targetItemData &&
            linkedColumns.some(linkedColumn => {
                if (linkedColumn.id !== target.columnId) {
                    return false;
                }
                // get linked fields that have configured source and target values
                const linkedFields = (linkedColumn.fields || []).filter((field) => {
                    return !!(field.source && field.target);
                });
                return (linkedFields.length > 0 &&
                    linkedFields.every(field => {
                        const sourceValues = sourceItemData.fields[field.source];
                        const targetValues = targetItemData.fields[field.target];
                        // find match for source and target values
                        return sourceValues.some(sourceValue => {
                            return targetValues.includes(sourceValue);
                        });
                    }));
            }));
    };
    return useTraceBoard({ columns, createItem, isLinked });
}
//# sourceMappingURL=useSiteTraceBoard.js.map